import { render, staticRenderFns } from "./cardChat.vue?vue&type=template&id=0bc74a76&"
import script from "./cardChat.js?vue&type=script&lang=js&"
export * from "./cardChat.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports